import { useEffect } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/**
 * ScrollTrigger caches element positions when a trigger is created. Images that
 * decode later, or list items appended by the infinite scroll, change those
 * positions and leave triggers firing at the wrong scroll offset.
 *
 * Call this with a value that changes whenever the page grows.
 */
export default function useScrollRefresh(dep) {
  useEffect(() => {
    const id = window.requestAnimationFrame(() => ScrollTrigger.refresh());
    return () => window.cancelAnimationFrame(id);
  }, [dep]);

  useEffect(() => {
    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener("load", onLoad);
    return () => window.removeEventListener("load", onLoad);
  }, []);
}
